import script from "./ComposeFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./ComposeFooter.vue?vue&type=script&setup=true&lang=js"

import "./ComposeFooter.vue?vue&type=style&index=0&id=7f539782&lang=css"

const __exports__ = script;

export default __exports__